<template>
  <div :class="card">
    <!--<div class="row no-gutters">-->
    <div class="pure-g">
      <!-- <div class="col-sm-10"> -->
      <div class="pure-u-xl-21-24 pure-u-lg-21-24 pure-u-md-20-24 pure-u-sm-20-24 pure-u-20-24">
        <div class="user-avatar">
          <div class="img-avatar"
            :style="{ 'background-image': 'url(' + miconfig.noticiero_img + '), url(' + defaultImage + ')', 'width': '40px', 'height': '40px' }">
          </div>
          <div class="data-avatar">
            <p :class="{'user-name hora-r blink': config.new ,'user-name': !config.new }"  v-if="miconfig.noticiero_nombre">
              {{ miconfig.noticiero_nombre.length > 20 ?
                miconfig.noticiero_nombre.slice(0, 20) + '...' : miconfig.noticiero_nombre }}
            </p>
            <p class="user">
              @{{ miconfig.key_src }}
            </p>
          </div>
        </div>
      </div>
      <!-- <div class="col-sm-2">-->
        <div class="pure-u-xl-3-24 pure-u-lg-3-24 pure-u-md-4-24 pure-u-sm-4-24 pure-u-4-24">
        <a :href="miconfig.link ? miconfig.link : miconfig.media" target="_BLANK" v-if="miconfig.entrada == 'FB'"
          class="button more-button noPadding noMargin tooltip tooltip-left" :data-tooltip="getTooltip(miconfig.entrada)">
          <img v-if="config.new" src="/assets/img/facebook.png" alt="Icon"  width="23px" height="20px" >
          <svg class="svgFB" v-else width="30px" height="30px" viewBox="0 0 24 24">
            <path
              d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z" />
          </svg>
        </a>
        <a :href="miconfig.link ? miconfig.link : miconfig.media" target="_BLANK" v-if="miconfig.entrada == 'TW'"
          class="button more-button noPadding noMargin tooltip tooltip-left" :data-tooltip="getTooltip(miconfig.entrada)">
          <img v-if="config.new" src="/assets/img/x.png" alt="Icon"  width="25px" height="23px" >
          <svg class="svgTW" v-else xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px" height="30px"
            preserveAspectRatio="xMidYMid meet" viewBox="0 0 4500 4500">
                <path d="M0 4579 c-2 -3 160 -224 359 -490 199 -266 622 -832 940 -1257 l578
        -773 -37 -42 c-21 -23 -446 -482 -944 -1020 -498 -539 -907 -983 -908 -988 -2
        -5 85 -9 210 -8 l213 1 70 77 c39 42 401 433 805 870 404 437 746 807 760 823
        l25 29 200 -268 c110 -147 413 -553 673 -901 l474 -632 725 0 c603 0 724 2
        720 13 -3 8 -187 256 -409 553 -222 296 -476 636 -564 754 -89 118 -350 469
        -582 778 -232 310 -422 568 -422 572 0 7 1226 1338 1643 1783 l119 127 -219 0
        -218 -1 -255 -276 c-140 -152 -483 -524 -763 -825 l-507 -548 -615 822 -616
        823 -725 5 c-399 3 -728 2 -730 -1z m1718 -886 c237 -318 603 -807 813 -1088
        210 -280 676 -904 1036 -1385 360 -482 658 -881 663 -888 6 -9 -65 -12 -324
        -12 l-331 0 -656 878 c-1514 2023 -2278 3045 -2287 3060 -6 9 62 12 323 12
        l331 0 432 -577z" />
          </svg>
        </a>
        <a :href="miconfig.link ? miconfig.link : miconfig.media" target="_BLANK" v-if="miconfig.entrada == 'I'"
          class="button more-button noPadding noMargin tooltip tooltip-left" :data-tooltip="getTooltip(miconfig.entrada)">
          <img v-if="config.new" src="/assets/img/instagram.png" alt="Icon"  width="25px" height="23px" >
          <svg class="svgInsta" v-if="miconfig.entrada == 'I'" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px" height="30px"
            preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
            <path
              d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3z" />
          </svg>
        </a>
        <a :href="miconfig.link ? miconfig.link : miconfig.media" target="_BLANK" v-if="miconfig.entrada == 'PD'"
          class="button more-button noPadding noMargin tooltip tooltip-left" :data-tooltip="getTooltip(miconfig.entrada)">
          <img v-if="config.new" src="/assets/img/periodico-n.png" alt="Icon"  width="27px" height="24px" >
          <svg class="svgDefault" v-else xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px" height="30px"
            preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
            <path d="M20 6v12H4V6h16m2-2H2v14s0 2 2 2h16s2 0 2-2V4m-12 9H6V8h4v5m8 0h-7v-2h7v2m0-3h-7V8h7v2z" />
          </svg>
        </a>
        <a :href="miconfig.link ? miconfig.link : miconfig.media" target="_BLANK" v-if="miconfig.entrada == 'TK'"
          class="button more-button noPadding noMargin tooltip tooltip-left" :data-tooltip="getTooltip(miconfig.entrada)">
          <img v-if="config.new" src="/assets/img/tiktok-n.png" alt="Icon"  width="25px" height="23px" >
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="20px" height="20px"
            viewBox="0 0 32 32">
            <path
              d="M16.708 0.027c1.745-0.027 3.48-0.011 5.213-0.027 0.105 2.041 0.839 4.12 2.333 5.563 1.491 1.479 3.6 2.156 5.652 2.385v5.369c-1.923-0.063-3.855-0.463-5.6-1.291-0.76-0.344-1.468-0.787-2.161-1.24-0.009 3.896 0.016 7.787-0.025 11.667-0.104 1.864-0.719 3.719-1.803 5.255-1.744 2.557-4.771 4.224-7.88 4.276-1.907 0.109-3.812-0.411-5.437-1.369-2.693-1.588-4.588-4.495-4.864-7.615-0.032-0.667-0.043-1.333-0.016-1.984 0.24-2.537 1.495-4.964 3.443-6.615 2.208-1.923 5.301-2.839 8.197-2.297 0.027 1.975-0.052 3.948-0.052 5.923-1.323-0.428-2.869-0.308-4.025 0.495-0.844 0.547-1.485 1.385-1.819 2.333-0.276 0.676-0.197 1.427-0.181 2.145 0.317 2.188 2.421 4.027 4.667 3.828 1.489-0.016 2.916-0.88 3.692-2.145 0.251-0.443 0.532-0.896 0.547-1.417 0.131-2.385 0.079-4.76 0.095-7.145 0.011-5.375-0.016-10.735 0.025-16.093z" />
          </svg>
        </a>
      </div>
    </div>
    <div :class="body">
      <div class="row">
        <div class="col-sm-12">
          <span class="post-description" v-html="getTitle()"></span>
        </div>
      </div>
    </div>
    <div class="card-actions">
      <!--  <span class="post-description">{{fecha}}</span>
      <button class="button" style="width:100%" @click="goToNote">
        Ver &nbsp;
        <font-awesome-icon icon="arrow-right" />
      </button>-->
      <div class="textPanel-footer">
        <div class="row no-gutters">
          <div class="col-10">
            <span class>{{ fecha }}</span>
          </div>
          <div class="col-2 button small noMargin noBackground linkArrow tooltip tooltip-top" data-tooltip="Ver más">
            <font-awesome-icon icon="arrow-right" @click="goToNote" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { strings } from "@/services/strings.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faLink, faArrowRight } from "@fortawesome/free-solid-svg-icons";

library.add(faLink);
library.add(faArrowRight);

export default {
  name: "textNote",
  props: ["config", "emptyItem", "from"],
  components: {},
  mixins: [strings],
  data() {
    return {
      url: this.$store.getters.getMainUrl,
      fecha: "",
      miconfig: {},
      card: ["card", "card-medios"],
      body: ["body"],
      defaultImage: this.$store.state.defaultNote
    };
  },
  computed: {
    token() {
      return this.$store.getters.getToken;
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  beforeMount() {
    console.log(this.config, "config ======>");
    if (this.from == "public") this.setConfig(this.config);
    else this.getItem();
  },
  methods: {
    getItem() {
      var post_data = {
        token: this.token,
        key: this.config.noteKey ? this.config.noteKey : this.config.key,
        entrada: this.config.entrada,
        logs:true
      };
      var self = this;
      axios
        .post(this.url + "getNote", JSON.stringify(post_data)) //petición
        .then(response => {
          if (response.data.success) {
            self.setConfig(response.data.data);
          }
        })
        .catch(function (error) {
          var response = { success: false, error: error };
          console.log(error);
        });
    },
    setConfig(miconfig = null) {
      moment.tz.setDefault("America/Mexico_City");
      this.miconfig = miconfig;
      console.log(this.miconfig,"miconfig =======>");
      var tmp = moment(this.miconfig.fecha);
      if(this.miconfig.entrada == "TK"){
        tmp = moment(this.miconfig.pubDate);
      }
      this.fecha = moment
        .tz(tmp, "America/Mexico_City")
        // .utc()
        // .local()
        .format("YYYY/MM/DD HH:mm:ss");

      switch (this.miconfig.entrada) {
        case "PD":
        case "R":
        case "T":
          this.miconfig.noticiero_img = this.miconfig.noticiero_img
            ? this.miconfig.noticiero_img
            : this.$store.state.defaultNoticiero;
          break;
        case "FB":
          this.miconfig.noticiero_img = this.miconfig.noticiero_img
            ? this.miconfig.noticiero_img
            : this.$store.state.defaultFacebook;
          break;
        case "TW":
          this.miconfig.noticiero_img = this.miconfig.noticiero_img
            ? this.miconfig.noticiero_img
            : this.$store.state.defaultTwitter;
          break;
        case "Y":
          this.miconfig.noticiero_img = this.miconfig.noticiero_img
            ? this.miconfig.noticiero_img
            : this.$store.state.defaultYoutube;
          break;
        case "I":
          this.miconfig.noticiero_img = this.miconfig.noticiero_img
            ? this.miconfig.noticiero_img
            : this.$store.state.defaultInstagram;
          break;
        case "TK":
          this.miconfig.noticiero_img = this.miconfig.noticiero_img
            ? this.miconfig.noticiero_img
            : this.$store.state.defaultTiktokN;
            this.miconfig.titulo = miconfig.title;
            this.miconfig.key_src = miconfig.autor;
            this.miconfig.noticiero_nombre =miconfig.autor;
            this.miconfig.inicio = "00:00:00";
          break;
      }
      if (this.miconfig.metadatos) {
        var new_item = this.miconfig.metadatos;
        this.miconfig.titulo = new_item.titulo
          ? new_item.titulo
          : this.miconfig.titulo;
        this.miconfig.descripcion = new_item.descripcion
          ? new_item.descripcion
          : this.miconfig.descripcion;
      }
    },
    goToNote() {
      this.$emit("goToNote", this.miconfig);
    },
    goToNotes() {
      this.$emit("goToNotes", this.miconfig);
    },
    getTitle() {
      var str = this.miconfig.titulo ? this.miconfig.titulo : this.miconfig.descripcion;
      if (str != undefined) {
        if (str.length > 200) {
          str = str.slice(0, 200);
          str += "...";
        }
        return str;
      } else {
        return '';
      }
    },
    getTooltip(entrada) {
      var tooltip = "";
      switch (entrada) {
        case 'I': tooltip = "ver en Instagram"; break;
        case 'FB': tooltip = "ver en Facebook"; break;
        case 'TW': tooltip = "ver en Twitter"; break;
        case 'PD': tooltip = "ver en Medio Digital"; break;
      }
      return tooltip;
    },
    handleResize() {
      var width = window.innerWidth;
      if (width <= 768) {
        if (this.from) {
          if (this.from == "slider") {
            if (this.card.length == 3) {
              this.card.pop();
            }
          }
        }
      } else {
        if (this.from) {
          if (this.from == "slider") {
            if (this.card.length == 2) {
              this.card.push("small_card");
            }
          }
        }
      }
    }
  }
};
</script>
<style scoped>
@keyframes blink {
  0% {
        color: rgb(0, 0, 0);
    }
    50% {
        color: #3fe6cd;
    }
    100% {
        color: #00b99e;
    }
}

.blink {
   
    animation: blink 2s infinite;
}
.hora-r {
    /* Estilos para cuando item.entrada es 'R' 
    color: #00B99E !important;*/
}
</style>
<style scoped>
.card.card-medios .body {
  padding: 4px;
}

.EmbeddedTweet {
  border: none !important;
}

.textPanel-footer {
  font-size: 12px;
  font-family: "Rubik", sans-serif;
  padding: 0px 0px 5px 0px;
}

.linkArrow {
  text-align: right;
  padding: 0px 5px 0px 0px;
  cursor: pointer;
}

.linkArrow:hover {
  color: #00b99e;
}

.channelStyle .card.card-medios {
  min-height: 240px;
}

.channelStyle .card-actions {
  position: absolute;
  bottom: 0px;
  width: 90%;
}

.channelStyle .card {
  padding: 15px;
}

.VueCarousel-slide .card {
  padding: 10px;
  margin-bottom: 0px;
}

.VueCarousel-slide .card-actions {
  position: absolute;
  bottom: 0px;
  width: 95%;
}

.VueCarousel-slide .card {
  border-top-right-radius: 5px !important;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  min-height: 270px;
  max-height: 270px;
}
</style>